import { initializeApp } from 'firebase/app'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'
import config from '@shared/config'
import { DEFAULT_LOCALE } from '@web/assets/i18n/index.js'

const firebaseApp = initializeApp(config.firebaseConfig)
const firebaseAuth = getAuth(firebaseApp)
const firebaseDb = getFirestore(firebaseApp)
const firebaseFunctions = getFunctions(firebaseApp)
const firebaseStorage = getStorage(firebaseApp)

firebaseAuth.languageCode = DEFAULT_LOCALE

let currentUserResolved = false

const getCurrentUser = async () => {
  const user = await new Promise((resolve, reject) => {
    if (currentUserResolved) {
      resolve(firebaseAuth.currentUser)
    } else {
      const unsubscribe = onAuthStateChanged(firebaseAuth, user => {
        currentUserResolved = !!user
        unsubscribe()
        resolve(user)
      }, reject)
    }
  })

  if (user) {
    user.token = await user.getIdTokenResult()
  }

  return user
}

export { firebaseAuth, firebaseDb, firebaseFunctions, firebaseStorage, getCurrentUser }
